module.exports = {
  title: {
    home: '首页',
    productCenter: '产品中心',
    applicationVideo: '应用视频',
    aboutDongju: '关于汉高',
    contactUs: '联系我们',
    downloadCenter: '下载中心',
    cpzl: '产品资料',
    rjxz: '软件下载',
    rjxz2: '软件下载',
    qtwj: '其他文件',
    login: '登录',
    register: '注册',
    search: '搜索',
    more: '更多',
    online: '在  线  咨  询',
    dqkj: '汉高科技',
    factory: '工厂',
    equipment: '设备',
    team: '团队',
    userCenter: '个人中心',
		kfzx: '客服咨询',
    zx: '咨询',
    wxkf: '微信在线客服',
    gsjj: '公司简介',
    zycp: '主营产品',
    gsry: '公司荣誉',
    c_name: '深圳汉⾼⾃动技术有限公司',
    product: '产品下载',
    video: '视频',
    download: '下载',
    engineer: '工程师',
    purchase: '采购',
    CompanyName: '公司名称',
    address: '地址',
    contacts: '联系人',
    phone: '电话',
    email: '企业邮箱',
    nikename: '用户名',
    pwd: '登录密码',
    yyzh: '已有账户',
    ljdl: '立即登录',
    total: '共',
    pages: '页',
    qg: '全国经营商',
    ljcg: '立即采购',
    cpcs: '产品参数',
    model: '型号',
    trip: '行程',
    dzjd: '动作角度',
    style: '款式',
    show: '显示全部',
    put: '收起',
    yyly: '应用领域',
    price: '价格',
    cgsl: '采购数量',
    xj: '小计',
    addcars: '加入购物车',
    cpjs: '产品介绍',
    wexz: '文档下载',
    submit: '保存',
		xxcs: '详细参数',
    cpxl: '产品系列',
    xhsm: '型号说明',
    shumo: '3D数模',
    zlxz: '资料下载',
    fj: '附件',
    jj: '简介',
    bbh: '版本号',
    fbsj: '发布时间',
    wjxz: '文件下载',
    wjsm: '文件说明',
    kp: '开票信息', 
    fl:'友情链接',
    eemail:'电子邮箱',
    xzxh:'请选择型号'
  },
  content: {
    about_hangao:'深圳汉⾼⾃动技术有限公司创⽴于2024年，专注于⼯⼚⾃动化领域电动执⾏器的研发与制造，且能够为客户提供定制化服务。公司的创始团队在⼯⼚⾃动化⾏业深耕16年，拥有多项具备独⽴⾃主知识产权的创新技术。公司所推出的产品，在电⼦制造、⽣物医药、汽车制造、轨道交通等诸多⼯业制造领域，以及航天航空、科研院所、武器制造、核⼯业等前沿科研领域均有着⼴泛的应⽤。',
    index_about_info: '深圳汉⾼⾃动技术有限公司坐落于深圳市宝安区沙井街道衙边社区同⽅创意⽂化产业园5栋；是一家集科研开发、生产销售、现代服务为一体的高新技术企业；是国家级重点职业学校的校企合作单位。公司现有数控机床33台，各类机械加工设备90余台；夹爪专研生产设备和实验平台10余台套。公司员工大专以上学历的比例达58%，拥有雄厚的研发生产能力。',
		index_down: '产品附件下载',
    about_info_2: '深圳汉高致力于工厂自动化领域的硬件、软件的标准化与模块化，提供一站式系统化的解决方案，降低该领域对人才、技术、设备的依赖，节省研发成本,提升设备的可靠性。公司的主营产品有: 电动手指、旋转平台、微型直线滑台、高性能直线滑台、坐标机手、工业机器人等。',
    about_info_3: '公司被评为二O一六年度“科技创新先进企业”，所有的上架产品均为自主研发生产，拥有完全独立的知识产权，产品广泛应用于生产制造、科研、军工等领域。',
    us_item1_title: '深圳市汉高自动技术有限公司',
    us_item1_info: '深圳汉⾼⾃动技术有限公司创⽴于2024年，专注于⼯⼚⾃动化领域电动执⾏器的研发与制造，且能够为客户提供定制化服务。公司的创始团队在⼯⼚⾃动化⾏业深耕16年，拥有多项具备独⽴⾃主知识产权的创新技术。公司所推出的产品，在电⼦制造、⽣物医药、汽车制造、轨道交通等诸多⼯业制造领域，以及航天航空、科研院所、武器制造、核⼯业等前沿科研领域均有着⼴泛的应⽤。',
    us_item2_title:'MackAutomationLLC</br>玛尔珂⾃动化有限公司（美国）',
    us_item2_info:'Mack Automation成立于1970年，由詹姆斯·弗兰克·玛尔珂创立，总部位于美国亚利桑那州弗拉格斯塔夫市。Mack拥有先进的设备和一支致力于第一次就把事情做好的高技能团队，专门从事液压和气动执行器、电动夹爪、电动模组和电动转台的研究、开发和制造。这些产品广泛应用于工业自动化项目，并销往全球。Mack Automation 很自豪能够服务于包括许多财富 500 强公司的客户群。即使在超过 50 年后，我们仍然继续向我们的第一批客户提供产品，这证明了我们对质量、可靠性和长期合作伙伴关系的承诺。',
    us_item3_title:"深圳汉⾼与MackAutomation的合作",
    us_item3_info:"在双⽅团队针对⽣产与管理体系展开深⼊磨合之后，深圳汉⾼与MackAutomation公司于2024年正式签署了深度合作协议，深圳汉⾼⾃动技术有限公司也由此应运⽽⽣。双⽅合作产品的⽣产管理以及质量体系皆由美国MackAutomation公司⼀⼿负责，⽽产品的⽣产组装环节则由Ma ck Automation旗下的精密机械⼚负责实施操作，以此确保合作产品的品质始终维持在国际⼀流⽔准之上。"
  },
  tips: {
    r1: '请输入公司名称',
    r2: '请输入地址',
    r3: '请输入联系人',
    r4: '请输入联系方式',
    r5: '请输入邮箱',
    r6: '请输入用户名',
    r7: '请输入密码',
    r8: '请输入正确的邮箱',
    l1: '用户名不能为空',
    l2: '密码不能为空',
    a1: '请输入详细地址',
    a2: '请输入收货人',
    a3: '是否删除?',
    a4: '请选择收货地址',
    o1: '注：对公账户打款成功后，请将转账记录发送至邮箱',
    s1: '请输入企业名称',
    s2: '请输入纳税人识别号',
    s3: '请输入企业地址',
    s4: '请输入开户银行',
    s5: '请输入银行账号'
  },
  member: {
    gwc: '购物车',
    cgdd: '采购订单',
    shdz: '收货地址',
    tcdl: '退出登录',
    shr: '收货人',
    lxdh: '联系电话',
    edit: '修改',
    confirm: '确认',
    cancel: '取消',
    del: '删除',
    dgzhdk: '对公账户打款',
    skrhm: '收款人户名',
    yhkh: '银行账号',
    khhh: '开户行号',
    khyh: '开户银行',
    all: '全选',
    orderNum: '订单编号',
    qrsh: '确认收货',
    js: '结算',
    yl: '预览',
    cpname: '产品名称',
    allshop: '全部商品',
    ys: '已选',
    shop: '商品',
    qymc: '企业名称',
    ns: '纳税人识别号',
    qydz: '企业地址',
    tjdz: '添加地址',
    piece: '件',
    yfje: '应付金额',
    y: '元',
    skf: '收款方',
    xyb: '下一步',
    yzf: '已支付'
  }
}
